export default __webpack_public_path__ + "static/media/lte.4269987a.png";